import React from 'react';
import { useTranslation } from 'react-i18next';
import { ApiUrls } from '@api/apiUrls';
import { TableProps } from '@components-shared/table/types';
import { keyMap } from '@locales/lokalise/keyMap';
import Table from 'components/shared/table';
import { getFormattedNumber } from 'utils/helper';
import {
  SALES_USER_PSP_OPERATION_GRID_ACTIONS,
  SALES_USER_PSP_OPERATION_GRID_COLUMNS,
  SALES_USER_PSP_OPERATION_GRID_FILTERS_FIELDS,
} from './constants';
import { ISalesUserPspOperationProps, ISalesUserPspOperationTotals } from './interfaces';

export const PspOperationList = (props: ISalesUserPspOperationProps) => {
  const { i18n } = useTranslation();

  const { type } = props;

  return (
    <Table
      tableId={`${type}-psp-operations`}
      columns={SALES_USER_PSP_OPERATION_GRID_COLUMNS as TableProps['columns']}
      filterFields={SALES_USER_PSP_OPERATION_GRID_FILTERS_FIELDS as TableProps['filterFields']}
      actions={SALES_USER_PSP_OPERATION_GRID_ACTIONS as unknown as TableProps['actions']}
      api={ApiUrls.salesUserPspOperations.grid}
      exportAPI={ApiUrls.salesUserPspOperations.export}
      apiGetTotals={{
        url: ApiUrls.salesUserPspOperations.gridTotals,
        totalRowAmountsExtractor: (data: ISalesUserPspOperationTotals) => {
          return {
            id: i18n.t(keyMap.tableTotal) as string,
            amount: getFormattedNumber(data?.totalAmount, { precision: 2 }),
            currency: data?.currency,
            amountUSD: getFormattedNumber(data?.totalAmountUSD, { precision: 2 }),
          };
        },
      }}
      parentContext={{ props }}
    />
  );
};
